/**
 * Viewport widths at or below this use portrait hero artwork on the home page.
 * Matches Tailwind’s default `sm` breakpoint (640px): mobile-first “small screens”.
 */
export const HOME_HERO_PORTRAIT_MEDIA = "(max-width: 639px)";

/**
 * Hero “stage” vertical size: must match `HeroSection` outer `<section>` and
 * the home pre/main background layers in `App.tsx` so images align to the hero.
 */
export const HOME_HERO_STAGE_MIN_CLASS =
  "min-h-[calc(100dvh-3rem+6rem)] sm:min-h-[calc(100vh-3rem+6rem)]";

/** Fixed height for absolutely positioned full-bleed bg layers (same calc as min above). */
export const HOME_HERO_STAGE_BG_HEIGHT_CLASS =
  "h-[calc(100dvh-3rem+6rem)] sm:h-[calc(100vh-3rem+6rem)]";
